module.exports = __webpack_public_path__ + "static/scientist4-3bcaebd6931804da31ec171622af8b1d.png";